// Mock data for UNIFICADOS project

export const mockData = {
  // Hero Section
  hero: {
    title: "UNIFICADOS",
    subtitle: "Um encontro que transforma vidas através da fé, união e propósito",
    description: "Retiro cristão para jovens que buscam conexão, crescimento espiritual e comunidade",
    cta: "Quero Participar",
    badge: "Projeto",
    image: "/inicio/jovens.jpeg"
  },

  // About Section
  about: {
    title: "Nossa História",
    content: "O UNIFICADOS nasceu do desejo de criar um espaço onde jovens possam se conectar com Deus e uns com os outros de forma autêntica. Acreditamos que quando nos unimos em propósito e fé, somos capazes de transformar não apenas nossas vidas, mas toda a comunidade ao nosso redor.",
    stats: [
      { number: "100+", label: "Jovens Alcançados" },
      { number: "2", label: "Edições Realizadas" },
      { number: "100%", label: "Transformação" }
    ]
  },

  // Team Section
  team: {
    title: "Nossa Equipe",
    subtitle: "Conheça os líderes que tornam tudo isso possível",
    members: [
      {
        id: 1,
        name: "Nathan",
        role: "Líder",
        description: "Apaixonado por conectar jovens através da fé e da música",
        image: "/pessoas/nathan.jpeg"
      },
      {
        id: 2,
        name: "Debora",
        role: "Líder",
        description: "Dedicada a criar experiências significativas e transformadoras",
        image: "/pessoas/debora.jpeg"
      },
      {
        id: 3,
        name: "Matheus",
        role: "Líder",
        description: "Comprometido em inspirar e equipar a próxima geração",
        image: "/pessoas/matheus.png"
      },
      {
        id: 4,
        name: "Jordana",
        role: "Líder",
        description: "Focada em construir comunidade e fortalecer relacionamentos",
        image: "/pessoas/Jordana.jpeg"
      }
    ]
  },

  // Sponsors Section
sponsors: {
  title: "Seja um Apoiador",
  subtitle: "Ajude-nos a transformar vidas e alcançar mais jovens",
  benefits: [
    {
      title: "Impacto Real",
      description: "Seu apoio transforma diretamente a vida de jovens em busca de propósito",
      icon: "heart"
    },
    {
      title: "Comunidade",
      description: "Faça parte de um movimento que está mudando gerações",
      icon: "users"
    },
    {
      title: "Transparência",
      description: "Relatórios completos de como cada contribuição é utilizada",
      icon: "shield"
    }
  ],
  partners: [
    // Patrocinadores originais
    { 
      name: "Tech-Net Internet", 
      logo: "/pessoas/Internet.jpeg"
    },
    { 
      name: "Marka Da Paz Outlet", 
      logo: "/pessoas/marka.jpeg"
    },
    { 
      name: "Confecções Marina", 
      logo: "/pessoas/marina.jpeg"
    },
    // NOVOS patrocinadores
    { 
      name: "Construborges", 
      logo: "/pessoas/construborges.jpeg"
    },
    { 
      name: "N9ne Digital Studio", 
      logo: "/pessoas/n9ne.png"
    }
  ],
  callToAction: "Entre em contato para mais informações sobre parcerias"
},

  // Gallery Section
  gallery: {
    title: "Momentos Inesquecíveis",
    subtitle: "Veja como cada encontro é especial",
    images: [
      { id: 1, url: "/galeria/foto1.jpeg", alt: "Momento de oração e entrega" },
      { id: 2, url: "/galeria/foto2.jpeg", alt: "Dinâmica em grupo" },
      { id: 3, url: "/galeria/foto3.jpeg", alt: "Momento de oração" },
      { id: 4, url: "/galeria/foto4.jpeg", alt: "Confraternização" },
      { id: 5, url: "/galeria/ensinamento.jpeg", alt: "Ensinamento" },
      { id: 6, url: "/galeria/comunhao.jpeg", alt: "Comunhão" }
    ]
  },

  // Registration Section
  registration: {
    title: "Próxima Edição",
    subtitle: "UNIFICADOS 2026",
    details: {
      date: "1 à 3 de Maio",
      location: "Local a ser anunciado",
      price: "R$ 150,00",
      ageRange: "12 a 24 anos",
      lotes: [
        { name: "1º Lote", price: "R$ 130,00", status: "Esgotado" },
        { name: "2º Lote", price: "R$ 150,00", status: "Ativo" },
        { name: "3º Lote", price: "R$ 180,00", status: "Em breve" }
      ],
      includes: [
        "Hospedagem completa",
        "Alimentação inclusa",
        "Material de apoio",
        "Acesso total às atividades",
        "Kit Unificados (Camiseta)"
      ]
    },
    cta: "Manifestar Interesse",
    note: "Vagas limitadas! As inscrições serão abertas em breve."
  },

  // Contact Section
  contact: {
    title: "Entre em Contato",
    subtitle: "Tire suas dúvidas ou compartilhe sua mensagem conosco",
    info: {
      instagram: "https://www.instagram.com/unificados2026_/",
      whatsapp: "https://wa.me/5562991653451",
      email: "contato@unificados.com",
      city: "Alexânia - GO"
    }
  },

  // Footer
  footer: {
    slogan: "Juntos somos mais fortes. Unidos em Cristo.",
    copyright: "© 2k26 UNIFICADOS. Todos os direitos reservados.",
    socials: [
      { name: "Instagram", url: "https://www.instagram.com/unificados2026_/", icon: "instagram" },
      { name: "WhatsApp", url: "https://wa.me/5562991653451", icon: "message-circle" }
    ]
  }
};